import React from 'react';
import { Star } from 'lucide-react';

const StarRating = ({ value, onChange, readonly = false, label }) => {
  const handleStarClick = (rating) => {
    if (!readonly && onChange) {
      onChange(rating);
    }
  };

  return (
    <div className="flex items-center space-x-2">
      {label && <span className="text-sm font-medium text-gray-700 min-w-0 flex-1">{label}</span>}
      <div className="flex items-center space-x-1">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((star) => (
          <button
            key={star}
            type="button"
            onClick={() => handleStarClick(star)}
            disabled={readonly}
            className={`${readonly ? 'cursor-default' : 'cursor-pointer hover:scale-110'} transition-all duration-200`}
            data-testid={`star-${star}`}
          >
            <Star
              className={`w-4 h-4 ${
                star <= value
                  ? 'text-yellow-400 fill-yellow-400'
                  : 'text-gray-300'
              } ${!readonly ? 'hover:text-yellow-300' : ''}`}
            />
          </button>
        ))}
        <span className="text-sm font-medium text-gray-600 ml-2" data-testid="rating-value">
          {value}/10
        </span>
      </div>
    </div>
  );
};

export default StarRating;